var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDenied(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "#002549",
    fillOpacity: 0.055
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#denied_svg__clip0_1144_24096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.334 67.104l-37.583 7.109a1.846 1.846 0 01-2.158-1.47L11.004 16.958a1.843 1.843 0 011.473-2.155l37.582-7.11a1.846 1.846 0 012.16 1.471L62.806 64.95a1.848 1.848 0 01-1.473 2.155z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.393 65.795l-36.25 6.857a.98.98 0 01-1.145-.78L12.63 17.257a.978.978 0 01.781-1.144l36.25-6.857a.98.98 0 011.145.78L61.174 64.65a.98.98 0 01-.781 1.144z",
    fill: "#4A4F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.762 63.597l-31.97 6.048a.875.875 0 01-1.026-.699L15.347 19.33a.873.873 0 01.7-1.023l31.97-6.048a.875.875 0 011.026.7l9.419 49.615a.878.878 0 01-.7 1.023z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.887 18.27l3.457 18.21a1.784 1.784 0 01-1.424 2.086l-14.417 2.728a1.787 1.787 0 01-2.09-1.422l-3.456-18.21a1.784 1.784 0 011.424-2.085l14.417-2.729a1.79 1.79 0 012.09 1.423zM48.365 61.995l-14.416 2.729a1.787 1.787 0 01-2.09-1.423L28.402 45.09a1.784 1.784 0 011.425-2.086l14.416-2.728a1.787 1.787 0 012.09 1.422l3.456 18.212a1.784 1.784 0 01-1.424 2.086z",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2 35.75l.14.73a1.784 1.784 0 01-1.425 2.086L29.5 41.295a1.787 1.787 0 01-2.09-1.422l-.097-.52c.525-1.273 1.608-2.469 3.758-2.875l9.78-1.85c1.917-.363 3.337.236 4.35 1.121z",
    fill: "#4A4F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.996 30.642a2.087 2.087 0 01-1.418 2.302c-.003 0-.003 0-.006.003-.057.018-.117.034-.174.049l-.027.006c-.04.009-.079.015-.118.021-.027.003-.054.01-.081.01a1.9 1.9 0 01-.452.004c-.01-.001-.021-.004-.03-.004-.045-.006-.09-.012-.136-.02a2.087 2.087 0 01.572-4.13 2.092 2.092 0 011.825 1.527c.018.075.033.154.045.232zM41.293 27.306a2.087 2.087 0 01-1.418 2.302c-.003 0-.003 0-.006.003-.057.019-.117.034-.175.049l-.027.006c-.039.009-.078.015-.117.021-.027.003-.054.01-.081.01a1.878 1.878 0 01-.452.004c-.01-.001-.021-.004-.03-.004a2.09 2.09 0 01-1.822-1.753 2.087 2.087 0 012.258-2.397 2.09 2.09 0 011.87 1.759z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.471 33.997a5.26 5.26 0 01-5.803-1.482l-.003-.003a5.11 5.11 0 01-.347-.448l-.084-.126-.055-.084-.081-.135a5.221 5.221 0 01-.691-3.078c0-.007 0-.013.002-.019a5.242 5.242 0 013.403-4.455 5.345 5.345 0 011.288-.303 5.265 5.265 0 014.536 1.81 5.24 5.24 0 01-2.165 8.324z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.639 25.673c-.581.16-1.494-.115-1.7-.98-.306.68-.986 1.303-1.63 1.418-.208.037-1.247-.109-.927-1.132-.219.71-2.27 2.662-3.554 2.08-.233 1.165-1 1.969-1.433 1.897.003-.105.008-.21.017-.315 0-.006 0-.012.003-.018a5.242 5.242 0 013.403-4.456 5.346 5.346 0 011.288-.303 5.265 5.265 0 014.533 1.81z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.654 20.027c1.1.964 2.13 3.894.815 5.39-1.314 1.497-4.474.991-5.575.027-1.1-.963-.926-2.957.388-4.454 1.317-1.493 3.274-1.923 4.372-.963z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.745 35.028c.27 1.428-.767 2.825-2.314 3.12-1.548.293-3.022-.63-3.293-2.058l5.607-1.062z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.378 34.614c.384-.073.602-.624.487-1.231-.115-.607-.52-1.04-.904-.968-.384.073-.602.624-.487 1.231.115.607.52 1.04.904.968zM41.524 30.184c.312-.235.263-.825-.11-1.318-.373-.493-.928-.703-1.24-.467-.312.235-.263.825.11 1.318.373.493.928.703 1.24.468z",
    fill: "#4A4F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.247 58.551c-.021 0-.042 0-.064-.003a.451.451 0 01-.386-.507c.092-.674.149-1.306.18-2.12a.45.45 0 01.9.038 21.627 21.627 0 01-.188 2.203.447.447 0 01-.442.39zM33.675 57.67a.45.45 0 01-.44-.553c.023-.102.053-.216.089-.352.24-.917.688-2.623.655-6.514-.014-1.59.463-2.858 1.41-3.764.983-.94 2.461-1.426 4.06-1.345 1.956.102 4.451 1.335 5.243 6.614.094.622.18 1.885.215 2.583.012.25-.18.46-.43.473a.444.444 0 01-.474-.43c-.031-.658-.117-1.906-.206-2.49-.563-3.755-2.041-5.722-4.394-5.848-1.35-.073-2.584.33-3.387 1.094-.76.73-1.141 1.773-1.13 3.105.033 4.015-.452 5.865-.686 6.753a8.3 8.3 0 00-.08.325.465.465 0 01-.445.35z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.884 59.395a.45.45 0 01-.426-.61 8.98 8.98 0 00.467-1.913.451.451 0 01.895.128 9.907 9.907 0 01-.515 2.1.452.452 0 01-.421.295zM41.523 59.505a.45.45 0 01-.444-.553c.44-1.88.608-4.157.451-6.087-.104-1.275-.48-2.92-.996-3.598-.323-.426-.85-.678-1.45-.698-.57-.024-1.09.188-1.397.543-.496.578-.483 1.174-.47 1.995v.09c.03 1.714.05 2.748-.2 4.009a.453.453 0 01-.533.352.45.45 0 01-.354-.531c.233-1.162.217-2.106.184-3.814v-.069c-.016-.884-.033-1.777.686-2.617.48-.563 1.27-.883 2.11-.86.873.025 1.654.409 2.143 1.055.745.982 1.089 3.02 1.175 4.07.166 2.02-.011 4.4-.472 6.366a.441.441 0 01-.433.347z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.307 60.342a.452.452 0 01-.426-.604c.945-2.657 1.274-5.902.905-8.902a.453.453 0 01.897-.11c.388 3.133.04 6.528-.95 9.315a.458.458 0 01-.426.3zM54.34 56.937a.448.448 0 01-.444-.366l-6.571-34.623a.45.45 0 11.888-.167l6.572 34.623a.45.45 0 01-.361.527c-.027.003-.054.006-.084.006z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#denied_svg__filter0_d_1144_24096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.286 76.359c6.494 0 11.758-5.265 11.758-11.759 0-6.494-5.264-11.758-11.758-11.758-6.494 0-11.759 5.264-11.759 11.758 0 6.494 5.265 11.759 11.759 11.759z",
    fill: "#4A4F55"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.927 68.498a1.235 1.235 0 01-1.746 1.745l-3.896-3.896-3.897 3.896a1.23 1.23 0 01-.873.362 1.235 1.235 0 01-.873-2.107l3.898-3.896-3.897-3.897a1.235 1.235 0 011.745-1.746l3.897 3.897 3.896-3.897a1.235 1.235 0 011.746 1.746l-3.896 3.897 3.896 3.896z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "denied_svg__clip0_1144_24096"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10.957 7.64)",
    d: "M0 0h62.086v68.719H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "denied_svg__filter0_d_1144_24096",
    x: 48.267,
    y: 52.422,
    width: 26.035,
    height: 26.037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.63
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0 0.333333 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1144_24096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1144_24096",
    result: "shape"
  })))));
}
export default SvgDenied;